import { invoiceQuantitiesForLot } from "../ReplenishmentBoxes/InvoiceQuantityChips"

// Expand each replenishment product into the reception-table rows: one row per lot for
// expirable products, a single row otherwise. Kept pure (no component state) so the
// per-lot column derivations are unit-tested directly — this logic feeds EN RECEPCIÓN /
// PROCESADAS / ESPERADAS and the correction dialog gate.
export const buildReceivedProductRows = (products) => {
  const productsData = []
  ;(products || []).forEach((product) => {
    // The paired serializer sends these as arrays; default to [] so a serializer that ever
    // emits null (rather than an empty array) blanks one row instead of throwing and taking
    // down the whole "Piezas recibidas" table. received_lots is already guarded below.
    const inReceptionByLot = product.in_reception_by_lot || []
    const stockByLot = product.stock_by_lot || []

    if (!product.has_expiration) {
      productsData.push({
        ...product,
        lot_id: null,
        lot_reception: inReceptionByLot.find((x) => x.lot_id == null)?.stock || 0,
        lot_stock: stockByLot.find((x) => x.lot_id == null)?.stock || 0,
        invoice_quantities: invoiceQuantitiesForLot(product, null),
      })
      return
    }

    // Merge declared lots (supplier receipts) with received lots (returns, where lots aren't
    // declared on replenishment_products), keyed by lot id: a lot that is both declared and
    // received yields one row, and a received-but-undeclared lot still gets its own — so
    // declaring one lot no longer hides the rest. Code/expiration come from product.lots when
    // the lot is declared (getLot finds them there); otherwise from the received lot's fields.
    const declaredLots = (product.lots || []).filter((lot) => lot.product_id == product.id)
    const receivedLots = product.received_lots || []
    const receivedById = new Map(receivedLots.map((receivedLot) => [receivedLot.lot_id, receivedLot]))
    const lotIds = [...new Set([...declaredLots.map((lot) => lot.id), ...receivedLots.map((receivedLot) => receivedLot.lot_id)])]

    if (lotIds.length === 0) {
      productsData.push({ ...product, lot_id: null, lot_reception: 0, lot_stock: 0, invoice_quantities: [] })
      return
    }

    lotIds.forEach((lotId) => {
      const receivedLot = receivedById.get(lotId)
      productsData.push({
        ...product,
        lot_id: lotId,
        lot_code: receivedLot?.unique_code,
        lot_expiration: receivedLot?.expiration_date,
        // Each column from its real per-lot source; a lot with no entry there means zero
        // (e.g. pieces already moved out of the reception location), NOT the received count —
        // that would show a phantom EN RECEPCIÓN.
        lot_reception: inReceptionByLot.find((x) => x.lot_id == lotId)?.stock ?? 0,
        lot_stock: stockByLot.find((x) => x.lot_id == lotId)?.stock ?? 0,
        // No per-lot quantity override: every lot row keeps the product-level expected count
        // (from replenishment_products), so ESPERADAS vs PROCESADAS still surfaces
        // over-reception instead of hiding it.
        invoice_quantities: invoiceQuantitiesForLot(product, lotId),
      })
    })
  })
  return productsData
}
